import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { FormModule } from '@portal-core/general/components/form/form.module';
import { SyndicateFormComponent } from '@portal-core/licenses/components/license-connectors/syndicate-form/syndicate-form.component';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [
    SyndicateFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    FormControlErrorMessageModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormModule
  ],
  exports: [
    SyndicateFormComponent
  ]
})
export class SyndicateFormModule { }
